
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/transactions",
      function () {
        return require("private-next-pages/dashboard/transactions/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/transactions"])
      });
    }
  